<template>
    <div class="rn-card box-card-style-default"
         :class="{'card-list-view': blogPostStyle === 'list'}">
        <div class="inner">
            <div class="thumbnail">
                <!-- <router-link class="image" :to="`/blog-details/${blog.id}`"></router-link> -->
                    <img class="w-100" :src="blog.img" :alt="blog.title">
                
            </div>
            <div class="content">
                <!-- <ul v-if="blogPostStyle === 'card'" class="rn-meta-list">
                    <li>
                        <router-link :to="''">
                            {{ blog.author }}
                        </router-link>
                    </li>
                    <li class="separator">/</li>
                    <li>{{ blog.publishedAt }}</li>
                </ul> -->
                <p class="title title_new">
                    {{ blog.title }}
                    <!-- <router-link :to="`/blog-details/${blog.id}`">
                        {{ blog.title }}
                    </router-link> -->
                </p>
                <div style="width:100%" v-for="item in blog.excerpt">
                    {{ item }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BlogPost',
        props: {
            blog: {},
            blogPostStyle: {
                type: String,
                default: 'card'
            }
        }
    }
</script>